import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActionButtonsService<ActionButtonEvent> {
  protected _eventSubject = new Subject<ActionButtonEvent>();
  public events = this._eventSubject.asObservable();

  dispatchEvent(event: ActionButtonEvent) {
    this._eventSubject.next(event);
  }

  clear() {
    this._eventSubject.next(null);
  }
}
